/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum IncomeType {
    INTEREST = 'INTEREST',
    TRACKING = 'TRACKING',
}
